<template>
  <div 
    class="scroll-to-top" 
    @click="scrollToTop" 
    style="z-index: 1001; pointer-events: auto;"
  >
    <div class="scroll-percentage">{{ scrollPercentage }}%</div>
    <!-- 科技网站专属：向上箭头 ⬆️ -->
    <i class="fas fa-chevron-up"></i>
    
  </div>
</template>

<script>
export default {
  name: 'ScrollToTop',
  data() {
    return {
      showScrollTop: false,
      scrollPercentage: 0
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
    
    // 页面加载完成后立即检查
    this.$nextTick(() => {
      this.handleScroll();
    });
    
    // 延迟检查，确保在footer区域时按钮能正常工作
    setTimeout(() => {
      this.handleScroll();
    }, 1000);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
  },
  methods: {
    onMouseDown() {
      console.log('Mouse down on scroll button');
    },
    onMouseUp() {
      console.log('Mouse up on scroll button');
    },
    onTouchStart() {
      console.log('Touch start on scroll button');
    },
    onTouchEnd() {
      console.log('Touch end on scroll button');
      this.scrollToTop();
    },
    scrollToTop() {
      console.log('ScrollToTop clicked!');
      // 使用最可靠的滚动方式
      try {
        // 方法1：现代浏览器的smooth滚动
        if ('scrollBehavior' in document.documentElement.style) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        } else {
          // 方法2：直接滚动
          window.scrollTo(0, 0);
        }
      } catch (error) {
        // 方法3：最后的保障
        console.warn('Scroll to top failed, using fallback:', error);
        window.scrollTo(0, 0);
      }
    },
    handleScroll() {
      // 获取页面总高度和当前滚动位置
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // 计算滚动百分比
      const maxScroll = documentHeight - windowHeight;
      this.scrollPercentage = maxScroll > 0 ? Math.round((scrollTop / maxScroll) * 100) : 0;
      
      // 简化的显示逻辑：只要不在页面顶部就显示按钮
      // 这样可以确保在footer区域和页面任何位置都能看到按钮
      const shouldShow = scrollTop > 100;
      
      // 更新显示状态
      if (shouldShow !== this.showScrollTop) {
        this.showScrollTop = shouldShow;
      }
      
      // 调试信息
      if (process.env.NODE_ENV === 'development') {
        console.log('Scroll Debug:', {
          scrollTop,
          windowHeight,
          documentHeight,
          maxScroll,
          shouldShow,
          percentage: this.scrollPercentage
        });
      }
    }
  }
}
</script>

<style scoped>
.scroll-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #7ec482, #6fb5d1);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(126, 196, 130, 0.3);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1001;
  opacity: 1;
  transform: translateY(0);
  overflow: hidden;
  /* 确保按钮可以点击 */
  pointer-events: auto;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.scroll-to-top:hover {
  transform: translateY(-5px) scale(1.1);
  box-shadow: 0 12px 35px rgba(126, 196, 130, 0.4);
}

.scroll-to-top:active {
  transform: translateY(0) scale(0.95);
}

.scroll-percentage {
  font-size: 0.7rem;
  color: white;
  font-weight: bold;
  line-height: 1;
  margin-bottom: 2px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  pointer-events: none;
}

.scroll-to-top i {
  color: white;
  font-size: 1.5rem;
  transition: all 0.4s ease;
  pointer-events: none;
  font-weight: bold;
  /* 向上箭头特殊效果 */
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.4);
}

.scroll-to-top:hover i {
  transform: translateY(-4px);
  text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
  color: #00bfff; /* 深天蓝色，现代科技感 */
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .scroll-to-top {
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
  }
  
  .scroll-percentage {
    font-size: 0.6rem;
    margin-bottom: 1px;
  }
  
  .scroll-to-top i {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .scroll-to-top {
    bottom: 15px;
    right: 15px;
    width: 45px;
    height: 45px;
  }
  
  .scroll-percentage {
    font-size: 0.55rem;
    margin-bottom: 1px;
  }
  
  .scroll-to-top i {
    font-size: 0.9rem;
  }
}
</style>
